import { FC, useMemo, memo } from 'react';

import { WidgetWithTableType } from '@/types';

import { ProgressLine } from '../ProgressLine';

import styles from './styles.module.scss';

import PassedIcon from '@/assets/icons/passed.svg?react';

export const TableData: FC<{ data: WidgetWithTableType }> = memo(({ data }) => {
  const { table } = data;

  const tableContent = useMemo(() => {
    return table.data.map((item) => (
      <div key={`${item.name} ${item.status}`}>
        <div className={styles.DetailsStats__body__line} />
        <div className={styles.DetailsStats__body}>
          <div className={styles.DetailsStats__body__category}>
            <p className={styles.DetailsStats__body__category__text} title={item?.name}>
              {item.name}
              {item.isVerified && <PassedIcon style={{ minWidth: '14px' }} />}
            </p>
          </div>

          <div className={styles.DetailsStats__body__status}>
            <span
              className={
                item.status === 'No' ? styles.DetailsStats__body__status__no : styles.DetailsStats__body__status__yes
              }
            />{' '}
            {item.status}
          </div>

          <div className={styles.DetailsStats__body__value}>{item.value}</div>

          <div className={styles.DetailsStats__body__percentage}>
            {item.status !== 'N/A' && (
              <>
                {`${item.percentage?.toFixed(2)}%`}
                <div className={styles.DetailsStats__body__percentage__margin} />
                <ProgressLine progressValue={item.percentage as number} status={item.status as 'Yes' | 'No'} />
              </>
            )}
          </div>
        </div>

        {item.subCategories && (
          <div className={styles.DetailsStats__subcategories}>
            {item.subCategories.map((subItem) => (
              <div key={`${subItem.name} ${subItem.status}`} className={styles.DetailsStats__body}>
                <div className={styles.DetailsStats__body__category}>
                  <p className={styles.DetailsStats__body__category__text} title={subItem?.name}>
                    {subItem.name}
                    {item.isVerified && <PassedIcon style={{ minWidth: '14px' }} />}
                  </p>
                </div>

                <div className={styles.DetailsStats__body__status}>
                  <span
                    className={
                      subItem.status === 'No'
                        ? styles.DetailsStats__body__status__no
                        : styles.DetailsStats__body__status__yes
                    }
                  />{' '}
                  {subItem.status}
                </div>

                <div className={styles.DetailsStats__body__value}>{subItem.value}</div>

                <div className={styles.DetailsStats__body__percentage}>
                  {subItem.status !== 'N/A' && (
                    <>
                      {`${subItem.percentage?.toFixed(2)}%`}
                      <div className={styles.DetailsStats__body__percentage__margin} />
                      <ProgressLine
                        progressValue={subItem.percentage as number}
                        status={subItem.status as 'Yes' | 'No'}
                      />
                    </>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    ));
  }, [table.data]);

  return (
    <div className={styles.wrapper__table}>
      <div className={styles.DetailsStats}>
        <div className={styles.DetailsStats__header}>
          <div className={styles.DetailsStats__header__category}> {table.headers[0]}</div>
          <div className={styles.DetailsStats__header__status}> {table.headers[1]}</div>
          <div className={styles.DetailsStats__header__value}> {table.headers[2]}</div>
          <div className={styles.DetailsStats__header__percentage}>{table.headers[3]}</div>
        </div>

        {tableContent}
      </div>
    </div>
  );
});

TableData.displayName = 'TableData';
